import React from 'react';
import { SBadge } from '@chargebee/sting-react';
import { GroupType } from '@bbkAdminComponents/experiences/audiences/edit-rule/rules-utils';
import { cs } from '@bbkAdminUtils/css-utils';

type PBProps = {
  value: GroupType;
  onChange: (group: GroupType) => void;
  disabled?: boolean;
};
export const AndOrPillButton: React.FC<PBProps> = ({
  onChange,
  value,
  disabled = false,
}) => {
  return (
    <div
      className={cs('tw-inline-block tw-select-none', {
        'tw-cursor-pointer': !disabled,
        'tw-cursor-not-allowed tw-opacity-50': disabled,
      })}
      onClick={() => {
        if (!disabled) {
          onChange(value === GroupType.AND ? GroupType.OR : GroupType.AND);
        }
      }}
    >
      <SBadge
        variant="neutral"
        size="medium"
        mode={value === GroupType.AND ? 'light' : 'outline'}
        className={cs('-tw-mr-0.5 tw-min-w-3xl tw-justify-center', {
          '!tw-rounded-r-none !tw-border-r-transparent':
            value !== GroupType.AND,
        })}
      >
        AND
      </SBadge>
      <SBadge
        variant="neutral"
        size="medium"
        mode={value === GroupType.OR ? 'light' : 'outline'}
        className={cs('-tw-ml-0.5 tw-min-w-3xl tw-justify-center', {
          '!tw-rounded-l-none !tw-border-l-transparent': value !== GroupType.OR,
        })}
      >
        OR
      </SBadge>
    </div>
  );
};
